<style scoped lang="scss">
  .cons{
    display: none;
  }
  @media screen and (max-width: 640px){
    .cons{
      display: block!important;
    }
    .con{
      display: none!important;
    }
  }
</style>
<template>
  <div class="mobile-img-box">
    <img :src="imgUrl('')" class="img-fluid con" :alt="imgAlt">
    <!-- 手机端 -->
    <img :src="imgUrl('_mobile')" class="img-fluid cons" :alt="imgAlt">
  </div>
</template>

<script>
export default {
  name: 'mobile-img',
  props:{
    url: {
      type: String
    },
    imgAlt: {
      type: String
    },
    type:{
      type: String,
      default:'png'
    }
  },
  computed:{
    imgUrl(){
      return (mobile) => {
        switch(this.type){
          case 'png':
            return require(`@/assets/${this.url}${mobile}.png`)
        }
      }
    },
  },  
}
</script>



// WEBPACK FOOTER //
// src/components/MobileImg.vue